import { BrowserAuthError, InteractionRequiredAuthError, PublicClientApplication, RedirectRequest } from "@azure/msal-browser";
import { msalConfig, appScopes, loginRequest } from "./authConfig";

export const msalInstance = new PublicClientApplication(msalConfig);

const getAccount = () => {
    const activeAccount = msalInstance.getActiveAccount();
    const accounts = msalInstance.getAllAccounts();

    if (!activeAccount && accounts.length === 0) {
        console.warn("No active account or accounts found.");
    }

    return activeAccount || accounts[0];
}

export const acquireAppAccessToken = async (scope?: string) => {
    const account = getAccount();

    const request = {
        scopes: [scope || appScopes.defaultAppApiScope],
        account,
        redirectUri: `${window.location.origin}/auth.html`
    };

    try {
        const authResult = await msalInstance.acquireTokenSilent(request);
        return authResult.accessToken
    } catch (error) {
        
        if (error instanceof InteractionRequiredAuthError || 
        (error instanceof BrowserAuthError && error.errorCode === "monitor_window_timeout")) {

            const redirectRequest: RedirectRequest = {
                ...request,
                redirectUri: `${window.location.origin}/`
            }

            if (error.claims) {
                redirectRequest.claims = error.claims;
            }
            try {
                await msalInstance.acquireTokenRedirect(redirectRequest);
            } catch (error) {
                console.error(error);
            }
        } else {
            console.error(error);
        }
    }
};
